import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon, SparklesIcon, ZapIcon, BarChart3Icon, ShoppingCartIcon } from 'lucide-react';
export function ProductsSection() {
  return <section className="section-padding bg-black relative border-y border-white/5" data-id="element-263">
      <div className="absolute inset-0 bg-[url('https://grainy-gradients.vercel.app/noise.svg')] opacity-10 mix-blend-overlay pointer-events-none" data-id="element-264" />

      <div className="text-center max-w-3xl mx-auto mb-16 relative z-10" data-id="element-265">
        <h2 className="text-4xl md:text-5xl font-bold mb-6" data-id="element-266">Our Products</h2>
        <p className="text-xl text-gray-400" data-id="element-267">
          Premium tools built to accelerate your ecommerce growth.
        </p>
      </div>

      <div className="max-w-3xl mx-auto relative z-10" data-id="element-268">
        {/* Apps Card */}
        <div className="group relative overflow-hidden rounded-3xl bg-gradient-to-b from-white/[0.08] to-transparent border border-white/10 p-1 hover:border-[#D4AF37]/30 transition-colors duration-500" data-id="element-269">
          <div className="absolute inset-0 bg-gradient-to-br from-[#D4AF37]/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-270" />
          <div className="relative h-full bg-[#0a0a0a] rounded-[23px] p-8 md:p-10 flex flex-col" data-id="element-271">
            {/* App Showcase Mockup */}
            <div className="w-full aspect-[16/10] rounded-xl border border-white/10 bg-black mb-8 overflow-hidden flex flex-col shadow-2xl" data-id="element-272">
              {/* Browser Header */}
              <div className="h-8 bg-white/5 border-b border-white/10 flex items-center px-3 gap-1.5 shrink-0" data-id="element-273">
                <div className="w-2.5 h-2.5 rounded-full bg-red-500/50" data-id="element-274" />
                <div className="w-2.5 h-2.5 rounded-full bg-yellow-500/50" data-id="element-275" />
                <div className="w-2.5 h-2.5 rounded-full bg-green-500/50" data-id="element-276" />
              </div>
              {/* Abstract App Grid */}
              <div className="relative flex-1 p-6 grid grid-cols-2 gap-4 bg-gradient-to-br from-[#D4AF37]/5 to-transparent" data-id="element-277">
                {[{
                icon: <ZapIcon className="w-5 h-5 text-[#D4AF37]" data-id="element-278" />,
                label: 'Automation'
              }, {
                icon: <BarChart3Icon className="w-5 h-5 text-[#D4AF37]" data-id="element-279" />,
                label: 'Analytics'
              }, {
                icon: <ShoppingCartIcon className="w-5 h-5 text-[#D4AF37]" data-id="element-280" />,
                label: 'Conversion'
              }, {
                icon: <SparklesIcon className="w-5 h-5 text-[#D4AF37]" data-id="element-281" />,
                label: 'AI Tools'
              }].map(item => <div key={item.label} className="flex items-center gap-3 rounded-lg bg-white/5 border border-white/10 px-4 py-3" data-id="element-282">
                    <div className="w-9 h-9 rounded-lg bg-[#D4AF37]/10 flex items-center justify-center border border-[#D4AF37]/20 shrink-0" data-id="element-283">
                      {item.icon}
                    </div>
                    <span className="text-sm font-medium text-gray-200" data-id="element-284">
                      {item.label}
                    </span>
                  </div>)}
              </div>
            </div>

            <div className="flex items-center gap-4 mb-4" data-id="element-285">
              <div className="w-12 h-12 rounded-xl bg-white/5 flex items-center justify-center border border-white/10" data-id="element-286">
                <SparklesIcon className="w-6 h-6 text-[#D4AF37]" data-id="element-287" />
              </div>
              <h3 className="text-3xl font-bold text-white" data-id="element-288">Shopify Apps</h3>
            </div>

            <p className="text-lg text-gray-400 mb-8" data-id="element-289">
              Smart tools designed to improve store performance and sales.
              Automation. Analytics. Conversion tools.
            </p>
            <div className="mt-auto" data-id="element-290">
              <Link to="/products#apps" className="inline-flex items-center gap-2 text-white font-semibold hover:text-[#D4AF37] transition-colors" data-id="element-291">
                Explore Apps{' '}
                <ArrowRightIcon className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-292" />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>;
}